import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "main" }
const _hoisted_2 = { class: "wrapper-clients" }
const _hoisted_3 = { class: "above-table" }
const _hoisted_4 = { class: "wrapper-table" }
const _hoisted_5 = { class: "table-users" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Title = _resolveComponent("Title")!
  const _component_Searcher = _resolveComponent("Searcher")!
  const _component_StandardButton = _resolveComponent("StandardButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Title, { title: "Clientes" }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_Searcher, {
          search: _ctx.query,
          "onUpdate:search": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.query) = $event))
        }, null, 8, ["search"]),
        _createVNode(_component_StandardButton, {
          buttonLabel: 'Crear cliente',
          onClick: _ctx.createClientOption
        }, null, 8, ["onClick"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("table", _hoisted_5, [
          _cache[1] || (_cache[1] = _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", null, "Identificación"),
              _createElementVNode("th", null, "No. identificación"),
              _createElementVNode("th", null, "Empresa"),
              _createElementVNode("th", null, "Contacto"),
              _createElementVNode("th", null, "Teléfono"),
              _createElementVNode("th", null, "Correo"),
              _createElementVNode("th", null, "Facturación"),
              _createElementVNode("th", null, "Editar"),
              _createElementVNode("th", null, "Eliminar")
            ])
          ], -1)),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredClients, (client, index) => {
              return (_openBlock(), _createElementBlock("tr", { key: index }, [
                _createElementVNode("td", null, _toDisplayString(client.identificationType), 1),
                _createElementVNode("td", null, _toDisplayString(client.identificationNumber), 1),
                _createElementVNode("td", null, _toDisplayString(client.company), 1),
                _createElementVNode("td", null, _toDisplayString(client.contactName), 1),
                _createElementVNode("td", null, _toDisplayString(client.contactEmail), 1),
                _createElementVNode("td", null, _toDisplayString(client.contactPhone), 1),
                _createElementVNode("td", null, _toDisplayString(client.billingEmail), 1),
                _createElementVNode("td", null, [
                  _createElementVNode("img", {
                    src: "assets/administrator/Edit.svg",
                    alt: "edit",
                    class: "icon-table",
                    onClick: ($event: any) => (_ctx.editTransaction(client))
                  }, null, 8, _hoisted_6)
                ]),
                _createElementVNode("td", null, [
                  _createElementVNode("img", {
                    src: "assets/administrator/Delete.svg",
                    alt: "delete",
                    class: "icon-table",
                    onClick: ($event: any) => (_ctx.selectDeletedClient(client))
                  }, null, 8, _hoisted_7)
                ])
              ]))
            }), 128))
          ])
        ])
      ])
    ])
  ]))
}